export default class Video{
    id;
    fileGuid;
    title;
    description;
    url1;
    url2;
    url3;

    constructor(fileName, url1, title, description, url2 = null, url3 = null, id = null){    
        this.id = id;
        this.fileGuid = fileName;
        this.url1 = url1;
        this.url2 = url2;
        this.url3 = url3;

        this.title = title;
        this.description = description;
    } 
}